import { render } from "./BarCharts.vue?vue&type=template&id=1db0d9cb"
import script from "./BarCharts.vue?vue&type=script&lang=js"
export * from "./BarCharts.vue?vue&type=script&lang=js"

import "./BarCharts.vue?vue&type=style&index=0&id=1db0d9cb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__